import { Typography } from '@mui/material'
import type { ReactNode } from 'react'

interface Props {
  children: ReactNode
}
export function SectionSubtitle(props: Props) {
  const { children } = props
  return (
    <Typography variant="subtitle1" color="text.secondary">
      {children}
    </Typography>
  )
}
